"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MessageDocumentQuickPulse.js.map